import request from './http';

// 删除角色信息
export const deleteRoleInfo = data => {
    return request({
        url: '/auth/sysRole/deleteRoleById/'+data,
        method: 'delete',
    })
}

// 分页查询角色信息
export const getRoleList = data => {
    return request({
        url: '/auth/sysRole/findRolePageList?pageNo='+data.pageNo+"&pageSize="+data.pageSize+"&roleName="+data.roleName+"&companyId="+data.companyId,
        method: 'get',
    })
}

// 新增或修改角色信息
export const addOrUpdateRoleInfo = data => {
    return request({
        url: '/auth/sysRole/addRoleInfo',
        method: 'post',
        data
    })
}

// 添加角色与部门数据权限表
export const addRoleGroup = data => {
    return request({
        url: '/auth/sysRole/addRoleGroup',
        method: 'post',
        data
    })
}

// 角色添加用户
export const assignmentUser = data => {
    return request({
        url: '/auth/sysUserRole/addUserRole',
        method: 'post',
        data
    })
}

// 复制角色信息
export const copyRoleInfo = data => {
    return request({
        method: 'get',
        url: '/auth/copy/copyRoleInfo?companyId='+data.companyId+"&oldCompanyId="+data.oldCompanyId
    })
}

// 数据权限分页查询用户信息
export const pageFindUserList = data => {
    return request({
        method: 'post',
        url: '/auth/access/pageFindDataUserInfo',
        data
    })
}

// 正常角色配置
export const pageFindDataUserInfo = data => {
    return request({
        method: 'post',
        url: '/auth/access/originAccessConfig',
        data
    })
}